export const defineCameraType = (label: string): boolean => {
  return /arriére|back|traseira|environment|posteriore|rückkamera/i.test(label)
}
